(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-list-item__container"><input class="hq-lighting-list-item__input" type="radio" id="{{$ctrl.option.minKelvin}}" name="kelvins-input" ng-value="$ctrl.key" ng-checked="$ctrl.hasPopular ? $ctrl.option.popular : $ctrl.value === $ctrl.key" ng-click="$ctrl.onChange({ value: $ctrl.key })"> <label for="{{$ctrl.option.minKelvin}}" class="hq-lighting-list-item"><div class="hq-lighting-list-item__title" tabindex="-1"><div>{{ \'KELVIN_\'+$ctrl.option.minKelvin | translate }}<br><span data-ng-bind-html="\'MAX_MIN_RESULT\' | translate:{ min: (($ctrl.option.minKelvin | number:0).replace(\',\', \'&nbsp;\')), max: (($ctrl.option.maxKelvin | number:0).replace(\',\', \'&nbsp;\')) }"></span> <span tabindex="-1" data-ng-if="$ctrl.option.popular" class="hq-lighting-list-item__popular">{{ \'MOST_POPULAR\' | translate }}</span></div></div><div class="hq-lighting-list-item__radio"><div class="hq-lighting-list-item__radio-button" tabindex="-1" role="radio"></div></div></label></div>',
    bindings: {
      onChange: '&',
      option: '<',
      hasPopular: '<',
      key: '<',
      value: '<'
    },
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingKelvinsListItem', component);
}());
